import React, { useEffect, useState } from "react";
import "../Countdown/Countdown.css";
import { updateStatBoolean } from "../Utils/index.js";
import LinearProgress from "@mui/material/LinearProgress";

const DailyDebtPaid = ({
  savedPaymentList,
  setCompletionPercent,
  displayError,
  accessToken,
  userId,
  setDisplayError,
  setUserStats,
}) => {
  const [debtPaid, setDebtPaid] = useState(0);
  const [allDebtsPaid, setAllDebtsPaid] = useState(false);
  const [localCompletionPercentage, setlocalCompletionPercentage] = useState(0);
  const putDateOfStatBoolean = localStorage.getItem("putDateOfStatBoolean");

  useEffect(() => {
    const numberOfCompletePayments = savedPaymentList.filter(
      (payment) => payment.complete
    ).length;
    setDebtPaid(numberOfCompletePayments);
  }, [savedPaymentList]);

  useEffect(() => {
    const totalPayments = savedPaymentList.length;
    const paidDebtCompletionPercent = debtPaid / totalPayments;
    setCompletionPercent(paidDebtCompletionPercent);
    setlocalCompletionPercentage(paidDebtCompletionPercent);
    const newAllDebtsPaid = paidDebtCompletionPercent === 1.0;

    if (newAllDebtsPaid && !allDebtsPaid) {
      setAllDebtsPaid(true);
      updateStatBoolean(
        accessToken,
        userId,
        newAllDebtsPaid,
        setDisplayError,
        setUserStats
      );
    }
  }, [
    debtPaid,
    savedPaymentList.length,
    accessToken,
    userId,
    setDisplayError,
    setCompletionPercent,
    allDebtsPaid,
    putDateOfStatBoolean,
    setUserStats,
  ]);

  return (
    <>
      <>
        <div className="timeleft" style={{ marginTop: "2rem" }}>
          {allDebtsPaid && displayError === "" ? (
            <>
              <div
                style={{
                  fontWeight: "bold",
                  paddingTop: "1rem",
                  paddingBottom: ".5rem",
                }}
              >
                DEBT PAID!
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>debt paid</div>
                <div>
                  {localCompletionPercentage >= 0.99
                    ? 100
                    : Math.floor(localCompletionPercentage * 100).toFixed(0)}
                  {"%"}
                </div>
              </div>
              <LinearProgress
                style={{ marginTop: ".5rem", marginBottom: ".5rem" }}
                variant="determinate"
                value={localCompletionPercentage * 100} // Convert to percentage
              />
            </>
          )}
        </div>
      </>
    </>
  );
};

export default DailyDebtPaid;
